module.exports = __webpack_public_path__ + "static/media/Honda@2x.c8c49aec.png";